import { render } from "./App.vue?vue&type=template&id=2df85a03"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2df85a03&lang=css"

import exportComponent from "/Users/zhangweifeng/Desktop/YuLiang/铁锤广告/tiechui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__